export default "__VITE_ASSET__41e781c2__"